import { render, staticRenderFns } from "./TgList.vue?vue&type=template&id=e51cdb42"
import script from "./TgList.vue?vue&type=script&lang=js"
export * from "./TgList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports